import {
  HTTP_STATUS_MESSAGES,
  SESSION_EXPIRED_MESSAGE,
} from "constants/apiErrorMessages";
import { HTTP_STATUS } from "constants/httpStatusCodes";
import { getApiErrorMessage } from "helpers/packageManagementApi";
import { notifySessionExpired } from "helpers/sessionExpiredNotifier";

const INVALID_TOKEN_MESSAGE_PATTERN =
  /invalid\s+(auth\s+)?token|token\s+is\s+invalid|authentication required|please\s+log\s+in|re-?authenticate|unauthorized/i;

const FORBIDDEN_AUTH_MESSAGE_PATTERN = /^forbidden$|^access denied$/i;

export const isInvalidTokenMessage = (message) => {
  if (typeof message !== "string" || !message.trim()) {
    return false;
  }

  return INVALID_TOKEN_MESSAGE_PATTERN.test(message.trim());
};

const isForbiddenDueToAuth = (status, data) => {
  if (status !== HTTP_STATUS.FORBIDDEN) {
    return false;
  }

  const message = getApiErrorMessage(data, "", status);

  if (FORBIDDEN_AUTH_MESSAGE_PATTERN.test(String(message).trim())) {
    return true;
  }

  if (message === HTTP_STATUS_MESSAGES[HTTP_STATUS.FORBIDDEN]) {
    return true;
  }

  return isInvalidTokenMessage(message);
};

export const isAuthenticationFailure = (status, data) => {
  if (status === HTTP_STATUS.UNAUTHORIZED) {
    return true;
  }

  if (isForbiddenDueToAuth(status, data)) {
    return true;
  }

  const message = getApiErrorMessage(data, "", status);
  return isInvalidTokenMessage(message);
};

export const throwIfFetchNotOk = (response, data, fallbackMessage) => {
  if (response.ok) {
    return;
  }

  if (isAuthenticationFailure(response.status, data)) {
    notifySessionExpired(SESSION_EXPIRED_MESSAGE);
    throw new Error(SESSION_EXPIRED_MESSAGE);
  }

  throw new Error(getApiErrorMessage(data, fallbackMessage, response.status));
};

export const getDisplayMessageForQueryError = (message) => {
  if (isSessionErrorMessage(message)) {
    return SESSION_EXPIRED_MESSAGE;
  }

  return message;
};

export const isSessionErrorMessage = (message) => {
  if (message === SESSION_EXPIRED_MESSAGE) {
    return true;
  }

  if (isInvalidTokenMessage(message)) {
    return true;
  }

  if (message === HTTP_STATUS_MESSAGES[HTTP_STATUS.UNAUTHORIZED]) {
    return true;
  }

  if (message === HTTP_STATUS_MESSAGES[HTTP_STATUS.FORBIDDEN]) {
    return true;
  }

  if (FORBIDDEN_AUTH_MESSAGE_PATTERN.test(String(message).trim())) {
    return true;
  }

  return false;
};
